import { render, staticRenderFns } from "./NewRule.vue?vue&type=template&id=4cb85190"
import script from "./NewRule.vue?vue&type=script&lang=js"
export * from "./NewRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports